import { render, staticRenderFns } from "./DeferredPlaceOrder.vue?vue&type=template&id=d1600f2a&scoped=true&"
import script from "./DeferredPlaceOrder.vue?vue&type=script&lang=ts&"
export * from "./DeferredPlaceOrder.vue?vue&type=script&lang=ts&"
import style0 from "./DeferredPlaceOrder.vue?vue&type=style&index=0&id=d1600f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1600f2a",
  null
  
)

export default component.exports